import type { CameraPresetId } from '../types'

export interface CameraPreset {
  id: CameraPresetId
  label: string
  position: [number, number, number]
  target: [number, number, number]
}

export const CAMERA_PRESETS: CameraPreset[] = [
  { id: 'front', label: 'Front', position: [0, 1.0, 3.2], target: [0, 0.85, 0] },
  { id: 'back', label: 'Back', position: [0, 1.0, -3.2], target: [0, 0.85, 0] },
  { id: 'side', label: 'Side', position: [3.2, 1.0, 0], target: [0, 0.85, 0] },
  { id: 'three-quarter', label: '¾', position: [2.2, 1.2, 2.2], target: [0, 0.9, 0] },
  { id: 'underneath', label: 'Under', position: [0.4, -1.6, 1.8], target: [0, 0.5, 0] },
]

export function getPreset(id: CameraPresetId): CameraPreset {
  return CAMERA_PRESETS.find((p) => p.id === id) ?? CAMERA_PRESETS[0]
}
